import Vue from "vue";
const Bus = new Vue();
export default Bus;

// 이벤트 버스 목록
//  송신                     //                수신
//                          //
//                          //
//                          //
//                          //



// WEBPACK FOOTER //
// ./src/EventBus.js